import { createRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { TaskType } from '@/features/workbench'
import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'
import { DateFilterEnum } from '@/utils/dateFilters'

import { RequiredActionsErrorComponent, RequiredActionsLayout } from './requiredActionsLayout'
import { REQUIRED_ACTION_TYPES } from '../../domain/requiredActionTypes'

export const REQUIRED_ACTION_STATUSES = ['Overdue', 'Open'] as const
export const RequiredActionStatusEnum = z.enum(REQUIRED_ACTION_STATUSES)

export type RequiredActionStatusType = z.infer<typeof RequiredActionStatusEnum>

export const requiredActionsSearchSchema = z.object({
  shipmentId: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  bookingId: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  status: z
    .array(RequiredActionStatusEnum)
    .nullish()
    .transform((data) => data ?? undefined),
  task: z
    .array(z.enum(REQUIRED_ACTION_TYPES))
    .nullish()
    .transform((data) => data ?? undefined),
  type: z
    .array(z.nativeEnum(TaskType))
    .nullish()
    .transform((data) => data ?? undefined),
  dueDateFrom: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  dueDateTo: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  dueDate: DateFilterEnum.nullish().transform((data) => data ?? undefined),
  query: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  showBookingsOnly: z
    .boolean()
    .nullish()
    .transform((data) => data ?? undefined),
})

export type RequiredActionsSearchType = z.infer<typeof requiredActionsSearchSchema>

export const requiredActionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/required-actions',
  validateSearch: requiredActionsSearchSchema,
  errorComponent: RequiredActionsErrorComponent,
  pendingComponent: RequiredActionsLayout,
  beforeLoad: ensureAuthenticatedUser,
}).lazy(() => import('./../requiredActions/requiredActionsWrapper').then((d) => d.Route))
